import { createFileRoute, redirect } from "@tanstack/react-router";
import { SUPPORT_TOOLS } from "~/modules/SupportTools/constants";
import { isSupportToolsEnabled } from "~/modules/SupportTools/utils";

export const Route = createFileRoute("/_protected/support-tools/$tool")({
  beforeLoad: ({ params }) => {
    // Check if Support Tools feature is enabled
    if (!isSupportToolsEnabled()) {
      throw redirect({ to: "/" });
    }

    const { tool } = params;

    // Validate that the tool exists
    const toolExists = SUPPORT_TOOLS.some((t) => t.path === tool);

    if (!toolExists) {
      // Redirect to support tools home if tool doesn't exist
      throw redirect({ to: "/support-tools" });
    }
  },
  component: () => {
    const { tool } = Route.useParams();

    // Find the tool and get its component (guaranteed to exist by beforeLoad validation)
    const toolConfig = SUPPORT_TOOLS.find((t) => t.path === tool)!;
    const ToolComponent = toolConfig.component;

    return <ToolComponent />;
  },
});
